// Header 组件 - 网站头部
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './index.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const location = useLocation();

  // 监听滚动事件，实现头部滚动效果
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // 路由变化时关闭移动端菜单
  useEffect(() => {
    setIsMenuOpen(false);
    setIsSearchOpen(false);
  }, [location]);

  // 处理搜索
  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      // 这里可以跳转到搜索结果页面
      console.log('搜索:', searchQuery);
      // 示例: navigate(`/search?q=${encodeURIComponent(searchQuery)}`);
    }
  };

  // 导航菜单项 - 删除了分类
  const navItems = [
    { name: '首页', path: '/' },
    { name: '文章', path: '/posts' },
    { name: '归档', path: '/archive' },
    { name: '关于', path: '/about' }
  ];

  return (
    <header className={`site-header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        {/* Logo 和网站名称 */}
        <div className="logo-area">
          <Link to="/" className="logo-link">
            <div className="logo-icon">📝</div>
            <span className="logo-text">我的博客</span>
          </Link>
        </div>

        {/* 桌面端导航 */}
        <nav className="desktop-nav">
          <ul className="nav-list">
            {navItems.map((item) => (
              <li key={item.path} className="nav-item">
                <Link 
                  to={item.path} 
                  className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
                >
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        {/* 右侧功能区域 */}
        <div className="header-actions">
          {/* 搜索按钮 */}
          <button 
            className="search-toggle"
            onClick={() => setIsSearchOpen(!isSearchOpen)}
            aria-label="搜索"
          >
            <span className="search-icon">🔍</span>
          </button>

          {/* 搜索框 */}
          {isSearchOpen && (
            <div className="search-overlay">
              <form className="search-form" onSubmit={handleSearch}>
                <input
                  type="text"
                  placeholder="搜索文章..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="search-input"
                  autoFocus
                />
                <button type="submit" className="search-submit" aria-label="提交搜索">
                  🔍
                </button>
                <button 
                  type="button" 
                  className="search-close"
                  onClick={() => setIsSearchOpen(false)}
                  aria-label="关闭搜索"
                >
                  ✕
                </button>
              </form>
            </div>
          )}

          {/* 用户操作区域 */}
          <div className="user-actions">
            {/* 写文章按钮 */}
            <Link to="/write" className="write-post-button">
              <span>✍️ 写文章</span>
            </Link>

            {/* 通知按钮 */}
            <button className="notification-button" aria-label="通知">
              <span className="notification-icon">🔔</span>
              <span className="notification-badge">3</span>
            </button>

            {/* 用户头像/登录按钮 */}
            <div className="user-menu">
              <button className="user-button">
                <img 
                  src="/images/avatar.jpg" // 修改为您的头像路径
                  alt="用户头像" 
                  className="user-avatar"
                />
              </button>
              {/* 下拉菜单可以在这里实现 */}
            </div>

            {/* 移动端菜单按钮 */}
            <button 
              className="mobile-menu-toggle"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-label="菜单"
            >
              <span className={`menu-icon ${isMenuOpen ? 'open' : ''}`}>
                {isMenuOpen ? '✕' : '☰'}
              </span>
            </button>
          </div>
        </div>
      </div>

      {/* 移动端导航菜单 */}
      <div className={`mobile-nav ${isMenuOpen ? 'open' : ''}`}>
        <div className="mobile-nav-content">
          <ul className="mobile-nav-list">
            {navItems.map((item) => (
              <li key={item.path} className="mobile-nav-item">
                <Link 
                  to={item.path} 
                  className={`mobile-nav-link ${location.pathname === item.path ? 'active' : ''}`}
                >
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>

          {/* 移动端用户操作 */}
          <div className="mobile-user-actions">
            <Link to="/write" className="mobile-write-button">
              ✍️ 写文章
            </Link>
            <Link to="/login" className="mobile-login-button">
              登录
            </Link>
            <Link to="/register" className="mobile-register-button">
              注册
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;